import api from './axios';

export const getRecipeComponents = () => api.get('/recipe-components/?page_size=500');
export const createRecipeComponent = (data) => api.post('/recipe-components/', data);
export const updateRecipeComponent = (id, data) => api.put(`/recipe-components/${id}/`, data);
export const deleteRecipeComponent = (id) => api.delete(`/recipe-components/${id}/`);

export const getRecipeComponentItems = (recipeComponentId) => {
  const url = recipeComponentId
    ? `/recipe-component-items/?recipe_component_id=${recipeComponentId}`
    : '/recipe-component-items/';
  return api.get(url);
};
export const createRecipeComponentItem = (data) => api.post('/recipe-component-items/', data);
export const updateRecipeComponentItem = (id, data) => api.put(`/recipe-component-items/${id}/`, data);
export const deleteRecipeComponentItem = (id) => api.delete(`/recipe-component-items/${id}/`);

export const getModifiers = () => api.get('/modifiers/?page_size=500');
export const createModifier = (data) => api.post('/modifiers/', data);
export const updateModifier = (id, data) => api.put(`/modifiers/${id}/`, data);
export const deleteModifier = (id) => api.delete(`/modifiers/${id}/`);

export const getModifierGroups = () => getModifiers();
export const createModifierGroup = (data) => createModifier(data);
export const updateModifierGroup = (id, data) => updateModifier(id, data);
export const deleteModifierGroup = (id) => deleteModifier(id);

export const getModifierOptions = (modifierGroupId) => {
  const url = modifierGroupId
    ? `/modifier-options/?modifier_group_id=${modifierGroupId}&page_size=500`
    : '/modifier-options/?page_size=500';
  return api.get(url);
};
export const createModifierOption = (data) => api.post('/modifier-options/', data);
export const updateModifierOption = (id, data) => api.put(`/modifier-options/${id}/`, data);
export const deleteModifierOption = (id) => api.delete(`/modifier-options/${id}/`);
